import { Component, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
    key: string;
}

@Component({
    selector: 'syn-magicbox-delete-metadata-dialog',
    templateUrl: 'magicbox-delete-metadata-dialog.component.html',
})
export class MagicboxDeleteMetadataDialogComponent {
    typedKey = '';
    onDeleteEmitter: EventEmitter<any>;

    constructor(
        public dialogRef: MatDialogRef<MagicboxDeleteMetadataDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        this.onDeleteEmitter = new EventEmitter();
    }

    public onDelete() {
        this.dialogRef.close();
        this.onDeleteEmitter.emit(null);
    }
}
